import React from 'react';
import classNames from 'classnames';
import './stylesheet.scss';
import { IMAGE_SOURCE } from '../../../../../constants/rails';

const Arrow = ({ active = false }) => <img className={classNames({ accordion: true, chevron: true, down: !active, up: active })} src={`${IMAGE_SOURCE}menu/chevron_black.svg`} alt={active ? '⏶' : '⏷'} />;

export default Arrow;
